import { render, staticRenderFns } from "./exchange-rates-archive.vue?vue&type=template&id=fdb5a024&"
import script from "./exchange-rates-archive.vue?vue&type=script&lang=js&"
export * from "./exchange-rates-archive.vue?vue&type=script&lang=js&"
import style0 from "./exchange-rates-archive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports